//////////////////
// Global Stats
//////////////////
App.GlobalStats = (function() {

	var globalStats, wrapperObj, globalObj, startTime;
	var selectors = {
		globalStats: ".block-global-stats",
    globalWrapper: ".global-stats-wrapper",
    startTime: "data-start-time",
    globalStat: ".global-stat",
		figure: ".stat-figure"
	};
  var flags = {
    START: "start-stats",
		INTERVAL: "interval"
  }

	/*
	Attach render queue
	*/
	function attach() {
		try {
			globalStats = $(selectors.globalStats);
			if(globalStats.length) {

				// Sniff for the module being shown
				var a = setInterval(function() {
					if(globalStats.hasClass("block-enter")) {
						init();
						clearInterval(a);
					}
				}, 500);
			}
		} catch(e) {
			console.log("Error setting up global stats ", e);
		}
	}

	/*
	Init
	*/
	function init() {
		$.each(globalStats, function(i, el) {

			wrapperObj = $(el).find(selectors.globalWrapper);
			globalObj = wrapperObj.find("global");
			var startTime = Number(wrapperObj.attr(selectors.startTime));

			if(startTime) {
				var int = setTimeout(animate, startTime, this, wrapperObj, globalObj[0]);
			}
		});
	}

	/*
	Animate the position of the global
	*/
  function animate(obj, wrapper, global) {
    wrapper.addClass(flags.START);

    // Get the stats
    var stats = wrapper.find(selectors.globalStat);
    $.each(stats, function(i, el) {
			var stat = $(el);

			// Get the text§
			var statFigure = stat.find(selectors.figure);
			var statValue = statFigure.text();

			// Extract the numerical value
			var statNum = statValue.match(/(\d*\.)?\d+/);
			var statParts = statValue.split(statNum[0]);

			// Set starting point
			var count = { figure: 0 };

			// Animate numbers
      var anim = gsap.to(count, { figure: Number(statNum[0]), duration: 6,
        onUpdate: function() {

					// Format to decimal or integer subject to origin figure
					var num = Math.round(Number(count.figure));
					if(!Number.isInteger(Number(statNum[0]))) {
						var fl =  Number(statNum[0] % 1).toFixed(1);
						var decimel = String(fl).split(".")[1];
						num = num + "." + decimel;
					}

					if(statParts.length == 2) {
						// statFigure.text(statParts[0] + Math.round(count.figure) + statParts[1]);
						statFigure.text(statParts[0] + num + statParts[1]);
					} else if(statParts.length == 1) {
						if(statNum.index == 0) {
							// Part is at the end
							// statFigure.text(Math.round(count.figure) + statParts[0]);
							statFigure.text(num + statParts[0]);
						} else {
							// Part is at the start
							// statFigure.text(statParts[0] + Math.round(count.figure));
							statFigure.text(statParts[0] + num);
						}
					} else {
						// statFigure.text(Math.round(count.figure));
						statFigure.text(num);
					}
        }
      });
    });
  }

	/*
	Fix the annoying colour variation in blue hues between Chrome etc
	*/
	function fixColourGlitch() {
		if(!globalObj) {
			return(false);
		}
		var isChromium = !!window.chrome;
		var isFF = 'MozAppearance' in document.documentElement.style;
		var isSafari = /varructor/i.test(window.HTMLElement);
		var filter = "";

		if(isChromium) {
			filter = "contrast(1.09) brightness(.79)";
		}
		if(isFF) {
			filter = "brightness(.85) contrast(.99)";
		}
		if(filter.length) {
			globalObj.css("filter", filter);
		}
	}

	App.register(function() {
		App.log("Registered: App.GlobalStats");
		attach();
	});

})();
